import { cookieService } from 'utils/cookieService/cookieService';

export const accessTokenCService = cookieService('xsolla_metaframe_token');
